"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupEnv = exports.requiredEnv = exports.isEnv = exports.Env = void 0;
const UILocation = __importStar(require("@dcl/ui-env/dist/location"));
var Env;
(function (Env) {
    Env["LOCAL"] = "local";
    Env["DEVELOPMENT"] = "dev";
    Env["STAGING"] = "stg";
    Env["PRODUCTION"] = "prod";
})(Env = exports.Env || (exports.Env = {}));
function isEnv(value) {
    switch (value) {
        case Env.LOCAL:
        case Env.DEVELOPMENT:
        case Env.STAGING:
        case Env.PRODUCTION:
            return true;
        default:
            return false;
    }
}
exports.isEnv = isEnv;
const getEnvFromTLD = UILocation.getEnvFromTLD;
const getEnvFromQueryParam = UILocation.getEnvFromQueryParam;
const ENVS = new Map();
function createEnvs(data = {}) {
    const result = {};
    if (typeof process !== 'undefined' && process.env) {
        Object.assign(result, process.env);
    }
    Object.assign(result, data);
    return result;
}
function getEnv() {
    if (typeof window !== 'undefined') {
        const envFromQueryParam = getEnvFromQueryParam(window.location);
        if (envFromQueryParam) {
            return envFromQueryParam;
        }
        const envFromTLD = getEnvFromTLD(window.location);
        if (envFromTLD) {
            return envFromTLD;
        }
        if (window.location.host.match(/^localhost:\d{4,4}$/) ||
            window.location.host.match(/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}:\d{4,4}$/)) {
            return Env.LOCAL;
        }
    }
    if (isEnv(process.env.DCL_DEFAULT_ENV || '')) {
        return process.env.DCL_DEFAULT_ENV;
    }
    if (isEnv(process.env.GATSBY_DCL_DEFAULT_ENV || '')) {
        return process.env.GATSBY_DCL_DEFAULT_ENV;
    }
    if (process.env.NODE_ENV === 'production') {
        return Env.PRODUCTION;
    }
    return Env.LOCAL;
}
function getEnvs() {
    const env = getEnv();
    if (!ENVS.has(env)) {
        ENVS.set(env, createEnvs());
    }
    return ENVS.get(env);
}
function env(name, defaultValue) {
    const envs = getEnvs();
    return (envs[name] ||
        envs['GATSBY_' + name] ||
        envs['REACT_APP_' + name] ||
        envs['STORYBOOK_' + name] ||
        defaultValue);
}
exports.default = env;
function requiredEnv(name) {
    const value = env(name, '');
    if (!value) {
        throw new Error(`Missing "${name}" environment variable. Check your .env.example file`);
    }
    return value;
}
exports.requiredEnv = requiredEnv;
function setupEnv(envs = {}) {
    for (const env of Object.keys(envs)) {
        if (isEnv(env)) {
            ENVS.set(env, createEnvs(envs[env]));
        }
    }
}
exports.setupEnv = setupEnv;
